import { GUIDES } from "@/data/guides";
import { PageHero } from "@/components/common/PageHero";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { PreviewCard } from "@/components/cards/PreviewCard";
import { CTASection } from "@/components/common/CTASection";
import { IMG } from "@/data/images";

export default function GuidesIndex() {
  return (
    <>
      <PageHero
        overline="Visitor Guides"
        title="Colosseum Visitor Guides"
        subtitle="In-depth, editorial guides to help you understand the history, plan your trip and make the most of every moment in ancient Rome."
        image={IMG.historic}
        breadcrumbs={[{ label: "Visitor Guides" }]}
      />

      <section className="container-wide py-14 md:py-20">
        <SectionHeading
          overline="Read before you go"
          title="Stories, history & practical wisdom"
          description="More than blog posts — considered guides written to genuinely improve your visit."
        />
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {GUIDES.map((g, i) => (
            <Reveal key={g.slug} delay={(i % 3) * 0.07}>
              <PreviewCard
                to={`/guides/${g.slug}`}
                image={g.heroImage}
                eyebrow={g.category}
                title={g.title}
                text={g.subtitle}
                meta={g.readTime}
                testId={`guide-card-${g.slug}`}
              />
            </Reveal>
          ))}
        </div>
      </section>

      <div className="container-wide pb-20">
        <CTASection />
      </div>
    </>
  );
}
